import { ReactNode } from 'react';

import { useTableSortingFlag } from '@/hooks/useTableSortingFlag';

import { TableSortingProvider } from '@/components/TableSortingProvider';

interface Props {
    children: ReactNode;
}

/** Reads the flag once for the whole app, instead of once per sortable header. */
export function TableSortingFlagProvider({ children }: Props) {
    return (
        <TableSortingProvider enabled={useTableSortingFlag()}>
            {children}
        </TableSortingProvider>
    );
}
